export enum DataLookUpType {
	SmartId = "SmartId",
	Spar = "Spar",
	Experian = "Experian",
}

export enum DataLookUpLevel {
	NoData = "NoData",
	Full = "Full",
	Partial = "Partial",
}

export interface DataLookUpResponse {
	informationLevel: DataLookUpLevel;
}

export interface DataLookUpState {
	informationLevel?: DataLookUpLevel;
}

export interface DataLookUpPayload {
	transactionId: string;
}
